import styled from '@emotion/styled'

import { Color, theme } from '../constants'

/**
 * Prevents the element from collapsing if the input is "".
 */
const NARROW_NO_BREAK_SPACE = ' '

const ErrorMessageElement = styled.div({
  color: Color.RED,
  fontSize: theme.font.size['6.5'],
  lineHeight: 1,
  paddingTop: 8,
  userSelect: 'none',
})

export type ErrorMessageProps = {
  errorMessage: string | null | undefined
  reserveSpace?: boolean
}

export const ErrorMessage = ({
  errorMessage,
  reserveSpace,
}: ErrorMessageProps) => {
  if (!errorMessage && !reserveSpace) {
    return null
  }

  return (
    <ErrorMessageElement>
      {errorMessage ? errorMessage : NARROW_NO_BREAK_SPACE}
    </ErrorMessageElement>
  )
}
